import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { getJSON } from '../../shared/util';

/* eslint-disable complexity */
function* fetchPrice({ payload }) {
    const [api, params] = yield all([
        select(state => state.api.host),
        select(state => state.api.params),
    ]);

    const [price, stored, qparams] = yield all([
        call(getJSON, `${api}/commerce/price/${payload.upc}`, params),
        select(state => state.cookie.promo || {}),
        select(state => state['query-params']),
    ]);

    const promo_ext = stored.order_promo_external || undefined;
    const promo_int = stored.order_promo_internal || undefined;

    let vparams = {
        partner: params.partner,
        key: params.key,
        placement: payload.placement || 'text-teeup-message',
        site: params.partner,
    };

    if (promo_ext) {
        /* if teeup of specific report, only send promo_ext if it matches the report */
        if (! promo_ext.value.includes('SVC-')
            ||
            (qparams.report && promo_ext.value.includes('SVC-' + qparams.report))) {
            vparams.order_promo_ext = promo_ext.value;
        }
    }

    if (qparams.report && promo_int && promo_int.value.includes(qparams.report)) {
        // TCA only one right now, make sure report matches to get report specific message
        vparams.order_promo_int = promo_int.value;
    }

    let promo = null;

    if (price.usd && price.usd.voucher_upc) {
        vparams.voucher__upc = price.usd.voucher_upc;
        promo = yield call(getJSON, `${api}/rules/voucher-ownership/promo`, vparams);
    }

    if (promo && promo[0] && promo[0].message) {
        if (price.usd) {
            price.usd.message = promo[0].message;
        }
        if (price.kc) {
            price.kc.message = promo[0].message;
        }
    }

    yield put({
        type: 'product:update',
        payload: {
            price: price,
        },
    });
}
/* eslint-enable complexity */

export function* root() {
    yield takeLatest('price:required', fetchPrice);
}
